// export const url = "http://127.0.0.1:5000/api";
export const url = "https://study.leomalay.com/api";

export const dispatchLoading = (dispatch, scope, value) =>
    dispatch({ type: "SET_LOADING", payload: { scope, value } });
export const dispatchError = (dispatch, scope, value = []) =>
    dispatch({ type: "SET_ERROR", payload: { scope, value } });
